'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var utils = require('../utils');
var clickoutside = _interopDefault(require('../directive/click-outside'));

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('transition', {
      attrs: {
        "name": "keyboard"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.show,
        expression: "show"
      }],
      staticClass: "keyboard-wrapper"
    }, [_vm.keyboardTip ? _c('div', {
      staticClass: "keyboard-tip"
    }, [_vm._v(_vm._s(_vm.keyboardTip))]) : _vm._e(), _vm._v(" "), _vm.safeImgStatus && _vm.paySafeInfo.safeImgUrl ? _c('div', {
      staticClass: "keyboard-safe"
    }, [_c('img', {
      attrs: {
        "src": _vm.paySafeInfo.safeImgUrl
      },
      on: {
        "error": _vm.safeImgFail
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "clickoutside",
        rawName: "v-clickoutside:touchstart",
        value: _vm.blurKeyboard,
        expression: "blurKeyboard",
        arg: "touchstart"
      }],
      staticClass: "keyboard",
      class: {
        'keyboard-with-button': _vm.withButton
      },
      on: {
        "touchstart": _vm.focus,
        "touchmove": _vm.blurKey,
        "touchend": _vm.blurKey,
        "touchcancel": _vm.blurKey
      }
    }, [_c('div', {
      staticClass: "keyboard-main"
    }, _vm._l(_vm.keys, function (item) {
      return _c('i', {
        key: item.key,
        class: [item.className, {
          active: item.key === _vm.active
        }],
        attrs: {
          "data-key": item.key
        },
        domProps: {
          "textContent": _vm._s(item.text)
        }
      });
    }), 0), _vm._v(" "), _vm.withButton ? _c('div', {
      staticClass: "keyboard-sider"
    }, [_c('i', {
      staticClass: "keyboard-delete",
      class: {
        active: _vm.active === 'delete'
      },
      attrs: {
        "data-key": "delete"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "keyboard-confirm",
      class: {
        active: _vm.active === 'confirm',
        enabled: _vm.buttonEnabled
      },
      attrs: {
        "data-key": "confirm"
      },
      domProps: {
        "textContent": _vm._s(_vm.buttonText)
      }
    })]) : _vm._e()])])]);
  },
  staticRenderFns: [],
  name: 'keyboard',
  props: {
    show: Boolean,
    value: String,
    withButton: Boolean,
    buttonText: {
      type: String,
      default: '确认'
    },
    keyboardTip: {
      type: String,
      default: ''
    },
    buttonEnabled: {
      type: Boolean,
      default: false
    },
    extraKey: {
      type: String,
      default: ' '
    },
    extraKeyRight: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 6
    },
    paySafeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  directives: {
    clickoutside: clickoutside
  },
  data: function data() {
    return {
      active: '',
      safeImgStatus: true
    };
  },
  computed: {
    keys: function keys() {
      var keys = [];

      for (var i = 1; i <= 9; i++) {
        keys.push({
          key: i + '',
          text: i + ''
        });
      } // 最后一行


      keys.push({
        key: this.extraKey,
        text: this.extraKey
      });
      keys.push({
        key: '0',
        text: '0'
      });
      keys.push({
        key: this.extraKeyRight || (this.withButton ? 'pack' : 'delete'),
        text: this.extraKeyRight || '',
        className: this.extraKeyRight ? '' : this.withButton ? 'keyboard-pack' : 'keyboard-delete'
      });
      return keys;
    }
  },
  methods: {
    safeImgFail: function safeImgFail() {
      this.safeImgStatus = false;
    },
    focus: function focus(event) {
      var target = event.target;
      this.$emit('focus', event);
      var elKey = target.dataset.key; // 此处是因为线上有些case:  使用custom-input不能输入，代码比较冗余，方便确认一下具体原因
      // 待确认具体原因后，可以进一步优化

      if (!elKey) {
        var elKeyByAttr = target.getAttribute('data-key');

        if (elKeyByAttr) {
          this.$emit('invalid-dataset', event);
          elKey = elKeyByAttr;
        }
      }

      this.active = elKey;

      if (!this.active) {
        this.$emit('invalid-input', event);
        return;
      }

      var stopPropagation = true;

      if (this.active === 'pack') {
        stopPropagation = false;
        this.blurKeyboard();
      } else if (this.active === 'delete') {
        this.$emit('input', this.value.slice(0, this.value.length - 1));
      } else if (this.active === 'confirm') {
        this.$emit('confirm');

        if (this.buttonEnabled) {
          stopPropagation = false;
          this.blurKeyboard();
        }
      } else {
        // 初始父组件传入的value为''，触发input后才为输入的值
        if (this.value.length < this.maxLength) {
          var value = (this.value + target.innerText).slice(0, this.maxLength);
          this.$emit('input', value);
          value.length === this.maxLength && this.$emit('complete');
        }
      }

      stopPropagation && event.stopPropagation();
    },
    blurKey: function blurKey() {
      this.active = '';
    },
    blurKeyboard: function blurKeyboard() {
      this.$emit('blur');
    }
  }
});

exports.default = index;
